export const UnderwriterMenuList = [
  {
    title: "Pending Applications",
    iconStyle: imagepaths.fileCircleCheckIcon,
    iconActive: imagepaths.fileCircleCheckIconActive,
    to: "/app/pendingapplications",
    id: "pendingapplications",
  }, {
    title: "Restructure Loan",
    iconStyle: imagepaths.fileCircleCheckIcon,
    iconActive: imagepaths.fileCircleCheckIconActive,
    to: "/app/restructureloan",
    id: "restructureloan",
  },
  {
    title: "My Applications",
    iconStyle: imagepaths.fileCircleCheckIcon,
    iconActive: imagepaths.fileCircleCheckIconActive,
    to: "/app/loanapplications",
    id: ["loanapplications", "loanapplicationsview"],
  },
  {
    title: "Loan Details",
    iconStyle: imagepaths.fileCircleCheckIcon,
    iconActive: imagepaths.fileCircleCheckIconActive,
    to: "/app/loandetails",
    id: "loandetails",
  },
  {
    title: "Dedup Check",
    iconStyle: imagepaths.DupeCheckIcon,
    iconActive: imagepaths.DupeCheckIconActive,
    to: "/app/dupecheck",
    id: "dupecheck",
  },
  {
    title: "BSA",
    iconStyle: imagepaths.fileCircleCheckIcon,
    iconActive: imagepaths.fileCircleCheckIconActive,
    to: "/app/bankstatementanalyzer",
    id: "bankstatementanalyzer",
  },
  {
    title: "BSA 2",
    iconStyle: imagepaths.fileCircleCheckIcon,
    iconActive: imagepaths.fileCircleCheckIconActive,
    to: "/app/bsa",
    id: "bsa",
  },
];
